window.dn = window.dn || {};

(function (metadata, $, undefined)
{
    metadata.DefaultOptions = {
        ItemsAvailable : [],
        ItemsSelected : [],
        MaxItems : 1
    }

    function ensureMetadataRegexConstruction(metadata)
    {
        // Turn Regex strings into actual RegExp objects, so that we're not doing
        // this every time the create/load methods are called.
        if (metadata.Options.Create)
        {
            if (typeof(metadata.Options.Create.Regex) === "string")
            {
                metadata.Options.Create.Regex = new RegExp(metadata.Options.Create.Regex, metadata.Options.Create.RegexFlags);
            }

            if (metadata.Options.Create.DataTransform)
            {
                // This is a hash mapping {{patterns}} to transform functions.
                $.each
                (
                    Object.keys(metadata.Options.Create.DataTransform), 
                    function(index, key)
                    {
                        metadata.Options.Create.DataTransform[key] = eval(metadata.Options.Create.DataTransform[key]);
                    }
                );
            }
        }

        if (metadata.Options.Query && typeof(metadata.Options.Query.Regex) === "string")
        {
            metadata.Options.Query.Regex = new RegExp(metadata.Options.Query.Regex, metadata.Options.Query.RegexFlags);
        }
    }

    metadata.Selectize = {};

    metadata.CreateSelectize = function(
        $root,
        uniqueId, 
        metadataObj,
        passedOptions,
        onItemAddedFunction,
        onItemRemovedFunction
        )
    {
        if (passedOptions == null || Object.keys(passedOptions).length == 0)
        {
            console.log("Using defaults...");
            passedOptions = metadata.DefaultOptions;
        }

        if (metadataObj.ItemsAvailable)
        {
            // Template calls for some default available items of its own, so 
            // append to the existing itemsAvailable.
            passedOptions.ItemsAvailable.push.apply(passedOptions.ItemsAvailable, metadataObj.ItemsAvailable);
        }

        if (metadataObj.ItemsSelected)
        {
            // Template calls for some default selected items of its own, so 
            // append to the existing itemsAvailable.
            passedOptions.ItemsAvailable.push.apply(passedOptions.ItemsSelected, metadataObj.ItemsSelected);
        }

        ensureMetadataRegexConstruction(metadataObj);

        metadataObj.ItemsAvailable = passedOptions.ItemsAvailable, // metadata.DefaultOptions.ItemsAvailable

        // Wire up the autosuggestion capability via selectize library. Items specified in
        // the `options` and/or `items` properties should be objects with properties, not just strings.
        // You can then define which of the item's properties are used as the reported "value" of
        // the item when selected (via `valueField`), which properties are searched (via `searchField`),
        // and how things should be rendered. 
        metadata.Selectize[uniqueId] = $root.find("#" + uniqueId).selectize(
        {
            /**
             * This controls how long we wait, in milliseconds, after the user stops
             * typing, before we hit the given URL to query for autosuggestions.
             */
            loadThrottle: dn.constants.WaitForAutosuggest,

            /**
             * Which property is returned as the "value" for the chosen item. Typically
             * this is the unique identifier for the item.
             * 
             * E.g. "UniqueId" for our Vehicle metadata
             * E.g. "Code" for our Symptoms metadata
             */
            valueField: metadataObj.Options.Identifier,

            /**
             * Which properties are searched during filtering based on 
             * what the user has typed into the field. 
             * 
             * E.g. ["Display", "Vin"] for our Vehicle metadata
             * E.g. ["Code"] for our Symptoms metadata
             */
            searchField: metadataObj.Options.Search.Fields,

            /**
             * Items to be autosuggested if the user clicks into the field,
             * before they even start typing, if any. Note that if the user has 
             * previously chosen a value and we're loading the form again, we'll add
             * that option onto any defined in the template, so that we can pre-select
             * it in the `items` property below.
             */
            options: passedOptions.ItemsAvailable,

            /**
             * Items to be pre-filled into the input field. Typically used for 
             * default values, or when the user has previously selected some value(s)
             * and we are re-displaying the form for them. 
             */
            items: passedOptions.ItemsSelected,

            /**
             * The field(s) to use for sorting, and the direction given, similar to SQL format.
             * We will then parse that format into the version preferred by Selectize. If the 
             * direction isn't specified, we'll assume ASCending.
             * 
             * If nothing is specified, Selectize will sort by $score descending.
             * 
             * E.g. ["Display asc", "$score desc"] gets turned into:
             * 
             * [
             *     {
             *         field: "Display",
             *         direction: "asc"
             *     },
             *     {
             *         field: "$score",
             *         direction: "desc"
             *     }
             * ] 
             */
            sortField: metadataObj.Options.Sort ? metadataObj.Options.Sort.map
                (
                    function(sortField) 
                    {
                        var parts = sortField.split(/\s+/, 2);

                        return {
                            field: parts[0],
                            direction: (parts[1] || "asc").toLowerCase()
                        };
                    }
                )

                : null,

            /**
             * If false, items created by the user will not show up as available options once they are unselected.
             */
            persist: true,


            /**
             * If true, the tab key will choose the currently selected item.
             */
            selectOnTab: metadataObj.Options.SelectOnTab,

            /**
             * Selectize plugins to use on this instance. See: 
             * 
             * https://github.com/selectize/selectize.js/blob/master/docs/plugins.md
             * https://github.com/selectize/selectize.js/tree/master/src/plugins
             */
            plugins: metadataObj.Options.Plugins,

            /**
             * The max number of items the user can select. 1 makes the control 
             * mono-selection, null allows an unlimited number of items. NOTE: This
             * is controlled at the Field level, not Metadata.
             */
            maxItems: passedOptions.MaxItems,

            /**
             * If `maxItems` is 1, the input will look like a dropdown box with
             * a single selection, unless `mode` is set to "multi". 
             */
            mode: (passedOptions.Mode || "multi"),

            /**
             * Whether or not to highlight matched parts of the suggested items, 
             * based on what text the user has typed.
             */
            highlight: metadataObj.Options.Highlight,

            /**
             * If true, the dropdown will be closed after a selection is made.
             */
            closeAfterSelect: metadataObj.Options.CloseAfterSelect,

            /** 
             * The string to separate items by. When typing an item in a multi-selection 
             * control allowing creation, then the delimiter, the item is added. If you 
             * paste delimiter-separated items in such control, the items are added at once. 
             * The delimiter is also used in the getValue API call on a text <input> tag to 
             * separate the multiple values. If null, defaults to comma `,`. */
            delimiter: metadataObj.Options.DelimiterForSplitting,

            /**
             * If true, we will hit the URL to query for autosuggestions, with an empty body,
             * when the form is loaded. 
             */
            preload: (metadataObj.Options.Preload || false),

            /**
             * If defined, this allows the user to create a new entry instead of 
             * just being able to select existing entries.
             */
            create: metadataObj.Options.Create 
                ? 
                (
                    metadataObj.Options.Create.Url

                    // If they've set the `Url` property, it means they want to 
                    // create the item at a remote endpoint.
                    ? function(input, callback) 
                    {
                        dn.autosuggest.CreateOrQuery
                        (
                            {
                                input: input, 
                                data: metadataObj.Options.Create.Data,
                                method: metadataObj.Options.Create.Method,
                                regex: metadataObj.Options.Create.Regex,
                                resultPath: metadataObj.Options.Create.ResultPath,
                                resultSubs: metadataObj.Options.Create.ResultSubs,
                                url: metadataObj.Options.Create.Url,
                                onSuccess: callback, 
                                onFailure: console.error
                            }
                        );
                    }

                    // Otherwise we'll just create the object as they indicated with the `.Data` property
                    : function(input)
                    {
                        if (metadataObj.Options.Create.Regex && !metadataObj.Options.Create.Regex.test(input))
                        {
                            // regex was passed in, and did NOT match the `input`, so just return
                            return;
                        }

                        // They have also provided data transform functions we should apply
                        // when interpolating values onto the newly created object. 
                        // Using JSON parse(stringify) to pass a deep clone into dn.Interpolate, to leave original untouched
                        return dn.Interpolate(
                                JSON.parse(JSON.stringify(metadataObj.Options.Create.Data)), 
                                metadataObj.Options.Create.DataTransform, input);
                    }
                )

                : null,

            createFilter: (metadataObj.Options.Create && metadataObj.Options.Create.Regex)
                ? function (query) 
                {
                    return metadataObj.Options.Create.Regex.test(query);
                }

                : null,

            /**
             * To perform autosuggestions you must supply a `QueryUrl` in metadata,
             * which we will use to query for the user's typed keywords, returning the
             * results back to the selectize callback.
             */
            load: metadataObj.Options.Query
                ? function(input, callback)
                {
                    dn.autosuggest.CreateOrQuery
                    (
                        {
                            input: input, 
                            data: metadataObj.Options.Query.Data,
                            method: metadataObj.Options.Query.Method,
                            regex: metadataObj.Options.Query.Regex,
                            resultPath: metadataObj.Options.Query.ResultPath,
                            resultSubs: metadataObj.Options.Query.ResultSubs,
                            url: metadataObj.Options.Query.Url,
                            onSuccess: function(results)
                            {
                                results.forEach(function(result)
                                {
                                    if (metadata.Selectize[uniqueId].options[result[metadataObj.Options.Identifier]])
                                    {
                                        // The option already exists, just overwrite it in case something underlying changed
                                        metadata.Selectize[uniqueId].updateOption(result[metadataObj.Options.Identifier], result);
                                    }
                                });

                                callback(results);
                            },
                            onFailure: function()
                            {
                                console.log("failed to load data")
                                callback
                            }
                        }
                    );
                }

                : null,

            onItemAdd: function(itemId, $element) 
            {
                onItemAddedFunction(itemId, $element)
            },

            onItemRemove: function(itemId, $element) 
            { 
                onItemRemovedFunction(itemId, $element)
            },

            // If `AutoSelect` is true, and only one item is returned from the query,
            // then we will automatically select the returned item. 
            onLoad: (metadataObj.Options.Query && metadataObj.Options.Query.AutoSelect)
                ? function(items) 
                {
                    if (items && items.length === 1) 
                    {
                        this.setTextboxValue(""); 
                        this.addItem(items[0][metadataObj.Options.Identifier], false); 
                    }
                }

                : null,

            score: metadataObj.Options.ScoreFunction
                ? eval(metadataObj.Options.ScoreFunction)
                : null,

            render: metadataObj.Options.Render 
                ? {
                    // The content inside the span 
                    item: function(data, escape) 
                    {
                        return '<div class="dn-selectize dn-metadata" style="' + (metadataObj.ColorPrimary ? 'background-color: ' + metadataObj.ColorPrimary + ';border-color: ' + metadataObj.ColorPrimary + ';' : '') + (metadataObj.ColorText ? 'color: ' + metadataObj.ColorText : '') + '">' + 
                                    '<div' + 
                                    // Popover attributes, if defined
                                    (
                                        metadataObj.Options.Render.ItemPopoverTemplate
                                            ? ' data-toggle="popover" title="" data-html="true" data-trigger="hover" data-placement="bottom" data-content="' + 
                                            metadataObj.Options.Render.ItemPopoverTemplate(data) +
                                                '"'
                                            : ''
                                    ) + 
                                    '>' +                         
                                    (metadataObj.Options.Render.Icon ? '<i class="' + metadataObj.Options.Render.Icon + '"></i> ' : '') +                     
                                    metadataObj.Options.Render.ItemBodyTemplate(data) + 
                            '</div>\
                        </div>';


                    },

                    // This is the items in the dropdown
                    option: function(data, escape) 
                    {
                        return '<div class="dn-metadata-choice">' + 
                        (
                            metadataObj.Options.Render.ChoiceHeaderTemplate
                                ? '<span class="dn-metadata-header">' + 
                                metadataObj.Options.Render.ChoiceHeaderTemplate(data) + 
                                    '</span> '
                                : ''
                        ) +                    
                        (                            
                            // Replace any {{JSPaths}} with the relevant data
                            metadataObj.Options.Render.ChoiceBodyTemplate
                                ? metadataObj.Options.Render.ChoiceBodyTemplate(data)
                                : ''
                        ) + 
                        '</div>'; 
                    },

                    option_create: (metadataObj.Options.Create && metadataObj.Options.Create.Function) ? eval(metadataObj.Options.Create.Function) : null,
                }

            : {}
        })[0].selectize;
    };

}(window.dn.metadata = window.dn.metadata || {}, jQuery));